import { createElement, forwardRef } from 'react';
import {
  MIN_GREGORIAN_CALENDAR_YEAR,
  MAX_GREGORIAN_CALENDAR_YEAR,
} from '../../Calendar/GregorianCalendarFacts';
import { YearInputProps } from '../__internal__';
import { IntegerInput } from '../__internal__/IntegerInput';
import { IntegerInputRef } from '../__internal__/';
import { useFormatLocale } from '../../../locale/formatting/useFormatLocale';
import { isThaiLocale } from '../../../locale/localeUtils';
import { convertGregorianYearToThaiYear } from '../DateUtil';
import { withLabels } from '../../withLabels';
import { createUseTextLocalizer } from '../../../locale/createUseTextLocalizer';
import bundle from '../NovaComponents-DatePicker-gui-icu.properties';

const IntegerInputWithLabels = withLabels(IntegerInput);
const useTextLocalizer = createUseTextLocalizer(bundle);

export const YearInput = forwardRef<IntegerInputRef, YearInputProps>(function YearInput(
  props,
  ref
) {
  const locale = useFormatLocale();
  const localize = useTextLocalizer();
  const minYearValue = !props.minDate
    ? MIN_GREGORIAN_CALENDAR_YEAR
    : isThaiLocale(locale)
    ? convertGregorianYearToThaiYear(props.minDate?.getFullYear())
    : props.minDate?.getFullYear();
  const maxYearValue = !props.maxDate
    ? MAX_GREGORIAN_CALENDAR_YEAR
    : isThaiLocale(locale)
    ? convertGregorianYearToThaiYear(props.maxDate?.getFullYear())
    : props.maxDate?.getFullYear();
  return (
    <IntegerInputWithLabels
      testId={props.testId}
      ref={ref}
      id={props.id}
      label={localize('year.label')}
      labelPosition="top"
      invalidMessageKey="invalidyear.msg"
      value={props.value}
      onChange={props.onChange}
      minValue={minYearValue}
      maxValue={maxYearValue}
      wrapLabel={false}
      fieldWidth="4.5rem"
    />
  );
});
